import { useContext } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';
import { useNavigate } from 'react-router-dom';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const StockCountExistingCountModal = () => {
  const { isEndOfMonthCountModalOpen,
    handleClose,
    setIsEndOfMonthCountModalOpen,
    existingStockCheckId,
    existingStockCheckStatus } = useContext(ScheduleCreateContext) as ScheduleCreateValues;
  const { t } = useTranslation('createStockCount');
  const navigate = useNavigate();
  const handleViewExisting = () => {
    setIsEndOfMonthCountModalOpen(false);
    if (existingStockCheckStatus === 1 || existingStockCheckStatus === 3) {
      navigate(`/store/perform-stock-count/${existingStockCheckId}`);
    }
    else {
      navigate(`/store/review-stock-count/${existingStockCheckId}`);
    }
  };

  return (
    <Dialog
      open={isEndOfMonthCountModalOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {t('stockCountExistsTitle')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="textMD"
          sx={{ my: 4, mx: 6 }}>
          {t('stockCountExists')}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ mt: 4, mb: 4, mr: 4 }}>
        <Button
          variant="secondary"
          onClick={handleClose}
          autoFocus
        >
          {t('cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={handleViewExisting}
          autoFocus
        >
          {t('viewExisting')}
        </Button>
      </DialogActions>
    </Dialog>
  );

};

export default StockCountExistingCountModal;